module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_6005.b4eddc77.png";